export class GetNameFromHash
{

	getCompetencyName(competency_id, competency_hash)
	{
		for(let competency of competency_hash)
		{
			if(competency.job_competency_id == competency_id)
			{
				return competency.job_competency_name;
			}
		}
	}

	getCompetencyNotes(competency_id, competency_hash)
	{
		for(let competency of competency_hash)
		{
			if(competency.job_competency_id == competency_id)
			{
				return competency.job_competency_notes;
			}
		}
	}


	getSubCompetencyName(competency_id, competency_hash)
	{
		let new_sub_competency_hash = [] 

		for(let competency of competency_hash)
		{
			new_sub_competency_hash = [...new_sub_competency_hash, ...competency.job_sub_competency_names];
		}

		for(let sub_competency_name of new_sub_competency_hash)
		{
			if(sub_competency_name.job_sub_competency_id == competency_id)
			{
				return sub_competency_name.job_sub_competency_name;
			}
		}
	}

	getSubCompetencyNotes(competency_id, competency_hash)
	{
		let new_sub_competency_hash = []

		for(let competency of competency_hash)
		{
			new_sub_competency_hash = [...new_sub_competency_hash, ...competency.job_sub_competency_names];
		}

		for(let sub_competency_name of new_sub_competency_hash)
		{
			if(sub_competency_name.job_sub_competency_id == competency_id)
			{
				return sub_competency_name.job_sub_competency_notes;
			}
		}
	}
}